import { manageCarrierServiceTypes } from '@/common/constants'
import { errorTypes } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

export const getErrorTypes = errors => {
  if (!errors) return {}
  return {
    carrierEmptyError: errors.find(error => error.type === errorTypes.carrierEmpty),
    invalidRegionError: errors.find(error => error.type === errorTypes.invalidRegionForCarrierService),
    invalidLocationError: errors.find(error => error.type === errorTypes.invalidLocationForCarrierService),
  }
}

export const getCarrierError = errors => {
  const { carrierEmptyError, invalidRegionError, invalidLocationError } = getErrorTypes(errors)

  if (carrierEmptyError) return carrierEmptyError

  return invalidRegionError || invalidLocationError || null
}

export const getHelperText = (errors, value, manageCarrierService) => {
  const { carrierEmptyError, invalidRegionError, invalidLocationError } = getErrorTypes(errors)

  if (carrierEmptyError) {
    return 'Este campo es requerido'
  }

  if (invalidRegionError || invalidLocationError) {
    return 'Este servicio no está disponible para el destino seleccionado/las regiones disponibles. Elija otro servicio logístico o ajuste las demás opciones.'
  }

  if (value && manageCarrierService === manageCarrierServiceTypes.auto) {
    return 'Conexión con transportista activada. Las etiquetas de envío se generarán automáticamente.'
  }
}
